<template>
  <el-dialog
    title="审核"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form size="small" :model="form" ref="form">
      <el-form-item
        label="是否同意"
        :label-width="formLabelWidth"
        prop="status"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-switch
          :active-value="1"
          :inactive-value="0"
          v-model="form1.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        label="审核意见"
        :label-width="formLabelWidth"
        prop="remark"
      >
        <el-input v-model="form1.remark" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submit" :disabled="submit_loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import UserApi from "@/api/user.js";
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "180px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false,
      isproduct: false,
      type: 10,
      num: 20,
      tableData: [],
      product_arr: [],
      form1: {
        // is_recommend: 0,
        // choice: 0,
        // location: [],
        // name: "",
        // peer_reward: "",
        // level_four_reward: "",
        // level_three_reward: "",
        // level_two_reward: "",
        status: 1,
        remark: "",
        id: ""
      }
    };
  },
  props: ["open_edit", "form"],
  created() {
    this.form.open_money = this.form.open_money == 1 ? true : false;
    this.form.open_points = this.form.open_points == 1 ? true : false;
    this.form.open_invite = this.form.open_invite == 1 ? true : false;
    // yong
    this.form1.id = this.form.id;
    this.dialogVisible = this.open_edit;
  },
  methods: {
    submit() {
      let self = this;
      self.submit_loading = false;
      self.$message({
        message: "恭喜你，审核成功",
        type: "success"
      });
      self.dialogFormVisible(true);
    },

    /*修改用户*/
    editGrade() {
      let self = this;
      let params = this.form1;
      // console.log("=====================>", thiss.form);
      params.agent_id = this.form.agent_id;
      params.name = this.form.name;
      params.peer_reward = this.form.peer_reward;
      params.level_four_reward = this.form.level_four_reward;
      params.level_three_reward = this.form.level_three_reward;
      params.level_two_reward = this.form.level_two_reward;

      params.level = this.form.level;
      params.product = self.tableData;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          if (params.is_default == 0) {
            params.open_money = params.open_money == true ? 1 : 0;
            params.open_points = params.open_points == true ? 1 : 0;
            params.open_invite = params.open_invite == true ? 1 : 0;
          } else {
            delete params.open_money;
            delete params.open_points;
            delete params.open_invite;
            delete params.upgrade_money;
            delete params.upgrade_points;
            delete params.upgrade_invite;
          }
          UserApi.dengjiedit(params, true)
            .then(data => {
              self.submit_loading = false;
              self.$message({
                message: "恭喜你，等级修改成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/protocol/part/Edit.vue